import { Calendar, User, Users, BookMarked, Monitor, CalendarCheck, CalendarRange, CalendarCheck2, ListTodo, X } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import fetchPatientData from '../../src/services/general/patientGeneralAPI.api'
import { useSidebar } from './SidebarContext'
import { motion, AnimatePresence } from 'framer-motion'

const ProviderSidebar = () => {
  const location = useLocation()
  const history = useHistory()

  const pathname = location.pathname
  const segments = pathname.split('/').filter(Boolean)
  const baseRoute = '/' + segments.slice(0, 3).join('/')
  const [providerName, setProviderName] = useState('')

  const { isSidebarOpen, closeSidebar, toggleSidebar } = useSidebar()

  const fetchProviderName = async () => {
    const username = localStorage.getItem('user')
    const providerResult = await fetchPatientData('SELECT', 'Provider', JSON.stringify({}))
    let ParsedResult = JSON.parse(providerResult.d)
    const match = ParsedResult.Data.find((item) => item.UserId === JSON.parse(username)?.Username)
    if (match) {
      setProviderName(match?.Name)
    }
  }

  useEffect(() => {
    fetchProviderName()
  }, [])

  const tabs = [
    // { id: 1, name: "Today's Appointments 2", icon: CalendarCheck, url: '/home/provider/today-appointment2' },
    { id: 1, name: "Today's Appointments", icon: CalendarCheck, url: '/home/provider/today-appointment' },
    { id: 2, name: 'Open Charts', icon: CalendarRange, url: '/home/provider/appointment' },
    // { id: 3, name: 'Signed Charts', icon: CalendarCheck2, url: '/home/provider/completed-appointment' },
    { id: 8, name: 'Pre-Signed Note', icon: CalendarCheck2, url: '/home/provider/pre-signed' },

    { id: 5, name: 'All Patients', icon: Users, url: '/home/provider/all-patients' },
    { id: 4, name: 'Education', icon: BookMarked, url: '/home/provider/educations' },
    { id: 6, name: 'Test Patients', icon: BookMarked, url: '/home/provider/test-appointment' },
    { id: 7, name: 'Tasks', icon: ListTodo, url: '/home/providerBacklog' },
  ]

  return (
    <AnimatePresence>
      {isSidebarOpen && (
        <motion.div
          key="provider-sidebar"
          // initial={{ x: -250, opacity: 0 }}
          // animate={{ x: 0, opacity: 1 }}
          // exit={{ x: -250, opacity: 0 }}
          // transition={{ duration: 0.3, ease: "easeInOut" }}
          className="provider-sidebar"
        >
          <div
            className="toggleSidebarButtonInSidebar text-white w-100"
            onClick={() => {
              toggleSidebar()
            }}
          >
            <X />
          </div>
          <div className="logged-in-user-tab d-flex align-items-center px-4 gap-2" style={{ width: '240px' }}>
            <User />
            <p>{providerName || ''}</p>
          </div>

          {tabs.map((tab) => {
            const isActive = baseRoute === tab.url
            return (
              <div key={tab.id} className={`all-user-tab d-flex align-items-center justify-content-between px-4 gap-2 ${isActive ? 'active-tab' : ''}`} onClick={() => history.push(tab.url)} style={{ cursor: 'pointer', width: '240px' }}>
                <p className="" style={{ fontWeight: 'normal' }}>
                  {tab.name}
                </p>
                <tab.icon size={20} />
              </div>
            )
          })}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default ProviderSidebar
